import { render } from "./MyTypeButton.vue?vue&type=template&id=66e0802d&scoped=true"
import script from "./MyTypeButton.vue?vue&type=script&lang=js"
export * from "./MyTypeButton.vue?vue&type=script&lang=js"

import "./MyTypeButton.vue?vue&type=style&index=0&id=66e0802d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e0802d"]])

export default __exports__